import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { StudentList } from '../app/components/student/student-list';
import { ProtectedRoute } from '@org/ui';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/students')({
  component: StudentsRoute,
});

function StudentsRoute() {
  const navigate = useNavigate({ from: '/students' });
  const { t } = useTranslation('admin');

  return (
    <ProtectedRoute requiredPermissions={['admin:all', 'students:*']}>
      <div className="space-y-6">
        <h1 className="text-2xl font-semibold tracking-tight px-6 pt-4">{t('sidebar.navigation.students')}</h1>
        <StudentList
          onCreateStudent={() => navigate({ to: '/students/new' })}
          onEditStudent={(student) =>
            navigate({ to: '/students/$studentId', params: { studentId: student.userId } })
          }
        />
        <Outlet />
      </div>
    </ProtectedRoute>
  );
}


